import { rightsholderBase2v, portalBase2v } from '@App/dicts/pathes'

export const dspRates = (year: string, month: string, dsp?: string) =>
    portalBase2v(`statements/rates/v2/years/${year}/months/${month}${dsp ? `/dsps/${dsp}` : ''}`)
export const ratePeriods = () => portalBase2v('statements/rates/v2/usageperiods')
export const rateDsps = () => portalBase2v('statements/rates/v2/dsps')
export const rateSheetDownload = (downloadLink: string) => portalBase2v(downloadLink)
export const royalties = (rightsholderId: number, year: string, month?: string) =>
    rightsholderBase2v(rightsholderId, `statements/payees/years/${year}${month ? `/months/${month}` : ''}`)
export const payeeActivityDownload = (pasLink: string) => portalBase2v(pasLink)
export const latestRoyalties = (rightsholderId: number) => rightsholderBase2v(rightsholderId, 'statements/options')
export const allPayees = (rightsholderId: number) => rightsholderBase2v(rightsholderId, 'payees')
export const statements = (rightsholderId: number, payee: string) =>
    rightsholderBase2v(rightsholderId, `statements/payees/${payee}`)
export const tsvRequest = (rightsholderId: number) => rightsholderBase2v(rightsholderId, 'statements/request')
export const annualTSVRequest = (rightsholderId: number) =>
    rightsholderBase2v(rightsholderId, 'statements/request/annual')
export const distributionSummary = (rightsholderId: number, year: string, month: string) =>
    rightsholderBase2v(rightsholderId, `report/summary/link?year=${year}${month ? `&month=${month}` : ''}`)

export const paymentsYTD = (rightsholderId: number) =>
    rightsholderBase2v(rightsholderId, `processing/analytics/paid/yeartodate`)
export const paymentsLastDistribution = (rightsholderId: number) =>
    rightsholderBase2v(rightsholderId, `processing/analytics/paid/lastdistribution`)
export const paymentsForDistributions = (rightsholderId: number, distributionCount: number) =>
    rightsholderBase2v(rightsholderId, `processing/analytics/paid/period/${distributionCount}`)
